import React, { useState } from 'react';

import { 
  Wrap,
  CheckboxWrap, 
  ButtonWrap,
  TermsWrap,
} from './styled';

const Terms = [
  '개인정보 수집 및 이용 목적 : 당첨자 선정 및 마케팅 활용',
  '수집하려는 개인정보의 항목 : 이름, 휴대폰 번호, 성별, 연령대, 응답 내용',
  '개인정보의 보유 및 이용기간 : 당첨자 선정 후 3개월간 보관 후 파기됩니다.',
  '본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 이벤트 참여가 제한됩니다.',
  '제공하신 개인정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
]

const Terms2 = [
  '개인 정보를 제공받는 자 : 크린토피아',
  '개인 정보를 제공받는 자의 개인 정보 이용 목적 : 당첨자 선정 및 경품 발송',
  '제공하는 개인 정보의 항목 : 이름, 휴대폰 번호, 주소, 제출 ID 값',
  '개인 정보를 제공받는 자의 보유 및 이용 기간 : 경품 발송 후 3개월간 보관 후 파기',
  '본 개인정보 제공에 동의를 거부할 권리가 있으며 동의 거부 시 당첨 취소됩니다.',
  '제공하신 개인 정보는 서비스 제공 용도 외에는 활용하지 않습니다.',
]

const Checkbox = ({
  name,
  label,
  isChecked,
  checkHander,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  function changeHandler() {
    setIsOpen(prev => !prev);
  }
  
  function matchTemrs() {
    if( name === 'checkType1') {
      return Terms;

    } else {
      return Terms2;
    }
  }
  
  return (
    <Wrap>
      <CheckboxWrap>
        <label className="checkbox-label">
          <input type="checkbox" 
            name={name}
            checked={isChecked} 
            onChange={checkHander} 
          />
          <span />
          
          <p>{label}</p>  
        </label>
              
        <ButtonWrap  isCheck={isOpen} onClick={changeHandler} className='svg-wrapper'>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3536 14.5606C17.1583 14.7558 16.8417 14.7558 16.6464 14.5606L12 9.91414L7.35355 14.5606C7.15829 14.7558 6.84171 14.7558 6.64645 14.5606C6.45118 14.3653 6.45118 14.0487 6.64645 13.8535L12 8.49992L17.3536 13.8535C17.5488 14.0487 17.5488 14.3653 17.3536 14.5606Z" fill="#326CF9"/>
          </svg>
      </ButtonWrap>
      </CheckboxWrap>

      {isOpen && (
        <TermsWrap>
          {matchTemrs()?.map((value, index) => (
            <li key={index}>{value}</li>
          ))}
        </TermsWrap>
      )}
    </Wrap>
  );
};

export default Checkbox;
